import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faFamily } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { startCase, kebabCase } from 'lodash';

import { Sanitize } from '@components/Sanitize';

import { CaseRequisition } from '@customTypes/requisition';
import { getRequisitionName, getTimelineStatusLabel } from '@helpers/requisition';
import { getPatientDetailsPath } from '@router/paths';

interface IProps {
  requisitions: CaseRequisition[];
}

export default function RelatedOrders({ requisitions }: IProps) {
  const navigate = useNavigate();

  if (!requisitions.length) return null;

  const onPatientAction = (patientId: string) => {
    navigate(getPatientDetailsPath(patientId));
  };

  return (
    <div className='patient-detail-order-content__related-orders'>
      <div className='d-flex align-items-center pt-1 pb-2 gap-1'>
        <FontAwesomeIcon icon={faFamily as IconDefinition} fontSize={16} aria-hidden />
        <p className='fs-sm fw-medium mb-0'>Related order(s):</p>
      </div>

      <ul className='d-flex gap-2 flex-wrap list-style-none mb-0 ps-0'>
        {requisitions.map(requisition => {
          const statusLabel = getTimelineStatusLabel(requisition);

          return (
            <li key={requisition.requisition_id} className='bg-body-tertiary rounded-1 py-2 px-3'>
              <p className='fs-xs fw-bold mb-0'>
                {requisition.requisition_id}
                {statusLabel ? ` - ${statusLabel}` : ''}
              </p>

              <div className='d-flex gap-2'>
                <Button
                  variant='link'
                  className='p-0 border-0 fs-sm text-decoration-none fw-medium'
                  onClick={() => onPatientAction(requisition.individual_id)}
                >
                  <Sanitize>{getRequisitionName(requisition)}</Sanitize>
                </Button>
              </div>

              <p className='fs-xs mb-0'>{startCase(kebabCase(requisition.relationship))}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
